import Vue from 'vue';
import SDLUtil from '@/utils/SDLUtil';
// For IE. el.after() isn't supported on IE
function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export default {
    inserted(el, binding, vnode) {
        const onClickClear = function() {
            if (el.disabled || el.readOnly) return;

            el.value = '';

            let event;
            if (typeof Event === 'function') {
                event = new Event('input');
            } else {
                // For IE
                event = document.createEvent('Event');
                event.initEvent('input', true, true);
            }
            el.dispatchEvent(event);

            if (binding.arg === 'onClick') {
                if (binding.value) binding.value();
            }
        };
        const ResetComponent = Vue.extend({
            render(h) {
                return h('i', {
                    on: { click: onClickClear },
                    class: ['clearable_clear'],
                    style: {
                        display: SDLUtil.isNull(el.value) ? 'none' : 'block',
                    },
                });
            },
        });

        vnode.elm.parentElement.classList.add('clearable'); // Parent must have 'clearable' class.

        const i = document.createElement('i');

        insertAfter(i, el);
        // el.after(i); // Not supported on IE

        const component = new ResetComponent();
        component.$mount(i);

        // const clearBtns = vnode.elm.parentElement.getElementsByTagName('i');
        const clearBtn = vnode.elm.parentElement.getElementsByTagName('i')[0];

        el.oninput = () => {
            if (el.value && !el.disabled && !el.readOnly) {
                clearBtn.style.display = 'block';
            } else {
                clearBtn.style.display = 'none';
            }
        };
    },
    update(el, binding, vnode) {
        // const clearBtns = vnode.elm.parentElement.getElementsByTagName('i');
        const clearBtn = vnode.elm.parentElement.getElementsByTagName('i')[0];

        if (el.value && !el.disabled && !el.readOnly) {
            clearBtn.style.display = 'block';
        } else {
            clearBtn.style.display = 'none';
        }
    },
};



// WEBPACK FOOTER //
// ./src/directives/clearable.js